import { Pcr } from '../../lib/types/models/pcr/pcr'
import { IdsInput } from '../../lib/types/utils'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function sendReminderToPcr(input: IdsInput) {
  return restApiClient
    .url(constructApiUrl(API.candidate.sendReminderToPcr.url, null))
    .post<Pcr, IdsInput>(input)
}
